export default __webpack_public_path__ + "static/media/html.357cbca2.svg";